import { useContext } from 'react';
import { WindowContext } from 'src/contexts/Window';

const useWindow = () => {
  return useContext(WindowContext);
};

export default useWindow;
